/**
 * Created by tatekim on 2017. 2. 2..
 */
(function() {
    'use strict';
    var app = angular.module('admin');
    var SAMPLE_COORDS = [
        [[166, 249], [172, 307], [185, 365], [196, 426], [213, 485], [242, 540], [283, 588], [328, 627], [378, 637], [429, 630], [475, 595], [521, 553], [558, 504], [580, 445], [596, 383], [614, 323], [625, 261]],
        [[195, 224], [230, 206], [272, 208], [311, 218], [350, 235], [442, 233], [482, 217], [523, 210], [565, 211], [599, 233], [394, 280], [393, 326], [393, 372], [392, 418], [357, 432], [372, 441], [391, 451], [408, 442], [426, 435]],
        [[243, 271], [271, 257], [307, 259], [331, 286], [300, 295], [264, 292], [456, 287], [482, 263], [517, 262], [546, 277], [522, 297], [488, 297]],
        [[324, 516], [363, 511], [387, 512], [411, 511], [446, 516], [410, 521], [386, 523], [362, 521]]
    ];
    var MAX_POINTS = [17, 19, 12, 8];

    app.constant('PERMISSIONS', {
        LOGIN: 'login',
        VIEW: 'view',
        MANAGE_USER: 'manage_user',
        MANAGE_SUPER: 'manage_super',
        MANAGE_GUEST: 'manage_guest',
        EDIT_QUIZ: 'edit_quiz',
        MANAGE_QUIZ: 'manage_quiz',
        DEVELOPER: 'developer',
        SECRET_CODE: 'secret_code',
        TRANSLATE: 'translate',
        EDIT_ARTICLE: 'edit_article',
        MANAGE_ARTICLE: 'manage_article'
    });

    app.constant('HOME_PATHS', {
        translator: '/quiz/tr',
    });

    app.service('vvError', function() {
        var errors = [];
        this.log = function(e) {
            errors.push(e);
        };

        this.getLog = function() {
            return errors;
        };

        this.clearLog = function() {
            errors.splice(0, errors.length);
        };

        this.isEmpty = function() {
            return errors.length == 0;
        };
    });

    app.filter('vvErrorStack', function(vvBrowser) {
        return function(error) {
            if (!error)
                return '';

            if (!error.stack)
                return error.message;

            if (vvBrowser.isSafari()) {
                return 'Error: ' + error.message + '\n' +
                    error.stack.split('\n').map(function(line) {
                        return '    at ' + line;
                    }).join('\n');
            }
            else {
                return error.stack;
            }
        }
    });

    app.service('vvFb', function($q, $rootScope) {
        this.rescrapeUrl = function(url) {
            return $rootScope.fbInitPromise
                .then(function() {
                    return $q(function(resolve, reject) {
                        FB.api('/v3.1/', {id: url}, function(response) {
                            if (!response || response.error) {
                                reject(response.error);
                                return;
                            }

                            if (response.og_object == null) {
                                FB.api('/v3.1/', 'post', {id: url, scrape: true}, function(response) {
                                    if (!response || response.error) {
                                        reject(response.error);
                                        return;
                                    }

                                    resolve(response);
                                });
                                return;
                            }

                            FB.api('/v3.1/' + response.og_object.id, 'post', {scrape: true}, function(response) {
                                if (!response || response.error) {
                                    reject(response.error);
                                    return;
                                }

                                resolve(response);
                            });
                        });
                    });
                }, function(error) {
                    if (error == 'no fb')
                        return $q.when();

                    return $q.reject({
                        code: 'fb',
                        message: error
                    });
                });
        };
    });


    app.service('vvAdminAuth', function($rootScope, $http, gettextCatalog) {
        var authPromise = null;
        var adminUserTypeList = [
            {
                type: 'super',
                name: 'Developer',
            },
            {
                type: 'manager',
                name: 'Admin Manager',
            },
            {
                type: 'editor',
                name: 'Content Editor',
            },
            {
                type: 'writer',
                name: 'Content Writer',
            },
            {
                type: 'translator',
                name: 'Translator',
            },
            {
                type: 'guest_manager',
                name: 'Guest Manager',
            },
            {
                type: 'guest',
                name: 'Guest',
            },
            {
              type: 'article_editor',
              name: 'Article Editor',
            },
            {
              type: 'article_manager',
              name: 'Article Manager',
            }
          // {
            //     type: 'deactivated',
            //     name: 'Deactivated',
            // },
        ];
        var adminAuth = this;
        var adminUserTypes = this.allTypes = {};
        angular.forEach(adminUserTypeList, function(entry) {
            adminUserTypes[entry.type] = entry;
        });
        var isAllowed = this.isAllowed = {};
        var allowedTypes = this.allowedTypes = [];
        var refresh = this.refresh = function() {
            return $http.get('/admin/data/me').then(function (resp) {
                $rootScope.user = resp.data;
                allowedTypes.splice(0, allowedTypes.length);
                angular.forEach(adminUserTypeList, function(typeEntry) {
                    if (isAllowed[typeEntry.type] = (resp.data.allowed_types.indexOf(typeEntry.type) >= 0)) {
                        allowedTypes.push(typeEntry);
                    }
                });

            }, function (err) {
                $rootScope.user = null;
            }).finally(function() {
                $rootScope.updatePermission($rootScope.user && $rootScope.user.permissions);
            });
        };
        this.initAuth = function() {
            if (!authPromise) {
                authPromise = refresh();
            }
            return authPromise;
        };

        this.myId = function() {
            return $rootScope.user && $rootScope.user.id;
        };
    });

    app.run(function($rootScope, $http, $window, vv, PERMISSIONS, vvAdminAuth) {
        $rootScope.exportEnabled = vv.getVvMetaData('exportEnabled');
        $rootScope.user = null;
        $rootScope.PERMITTED = {};
        $rootScope.PERMISSIONS = PERMISSIONS;

        $rootScope.isAllowed = vvAdminAuth.isAllowed;
        $rootScope.allowedTypes = vvAdminAuth.allowedTypes;

        $rootScope.updatePermission = function(perms) {
            $rootScope.PERMITTED = {};
            angular.forEach(perms, function(perm) {
                $rootScope.PERMITTED[perm] = true;
            });
        };
        $rootScope.$watch('user', function() {
            $rootScope.updatePermission($rootScope.user && $rootScope.user.permissions);
            console.log('user updated', $rootScope.user, $rootScope.PERMITTED);
        });
        $rootScope.authInitialized = false;
        vvAdminAuth.initAuth().then(function() {
            $rootScope.authInitialized = true;
        });
        $rootScope.refreshAuth = function() { vvAdminAuth.refresh(); };
        $rootScope.openLoginWindow = function() {
            vvAdminAuth.refresh();
            if ($rootScope.user == null) {
                $window.loginCallback = function() {
                    vvAdminAuth.refresh();
                };
                $window.open('/admin/login?return_url=0');
            }
        };
    });


    app.run(function($rootScope, $http, $q, $window, $location, vvBrowser, vv, gettextCatalog) {
        $rootScope.stage = vv.getVvMetaData('stage');
        $rootScope.showBrowserWarning = vvBrowser.isIe();

        $rootScope.onLogin = function() {
            $window.FB.getLoginStatus(function (response) {
                if (response.status === 'connected') {
                    console.log('on connected');
                    // $window.location.replace(vv.getVvMetaData('return_url'));
                } else {
                    $window.location.reload();
                }
            });
        };

        $rootScope.showSecret = function() {
            $http.get('/admin/data/register_secret.json').success(function (data, status, headers, config) {
                alert(data);
            }).error(function (data, status, headers, config) {
                alert(gettextCatalog.getString('요청 실패'));
            });
        };

        $rootScope.fbInitPromise = $q(function(resolve, reject) {
            $window.fbAsyncInit = function() {
                FB.init({
                    appId: $window.config['FBAppId'],
                    cookie: true,
                    status: true,
                    xfbml: true,
                    version: 'v3.1'
                });

                FB.Event.subscribe('auth.authResponseChange', function(response) {
                    if (response.status === 'connected') {
                        FB.api("/me", {fields: ["id", "name"]}, function(response) {
                            if (!response || response.error) {
                                console.log(response);
                                reject('/me failed');
                                return;
                            }
                            resolve({
                                id: response.id,
                                name: response.name
                            });
                        });
                    } else {
                        reject('not connected');
                    }
                });
            };

            $rootScope.vvSiteEnvSn = vv.getVvMetaData('env_sn');
            $rootScope.vvSiteStage = vv.getVvMetaData('stage');
            $rootScope.vvSiteRegion = vv.getVvMetaData('region');
            if ($rootScope.vvSiteRegion != 'cn' ||
                $location.host().search(/\.vonvon\.me$/) >= 0 ||
                $location.host().search(/\.fb\.vonvon\.net$/) >= 0) {
                (function (d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) { return; }
                    js = d.createElement(s);
                    js.id = id;
                    js.src = "//connect.facebook.net/en_US/sdk.js";
                    fjs.parentNode.insertBefore(js, fjs);
                }($window.document, 'script', 'facebook-jssdk'));
            } else {
                reject('no fb');
            }

            $rootScope.useIntroSquareImage = ($rootScope.vvSiteRegion == 'cn');
            $rootScope.useResultSquareImage = true;
        });
    });

    app.run(function (vv, vvL10n, $cookies, $rootScope, gettextCatalog) {
        var lang = vv.getVvMetaData('lang');
        var lang_on_cookies = $cookies.get('preferred_lang');
        if (lang_on_cookies) {
            lang = lang_on_cookies;
        }
        $rootScope.updateLang = function(lang) {
            $rootScope.lang = lang;
            if (lang in vvL10n.languageFiles) {
                gettextCatalog.setCurrentLanguage(lang);
                if (vvL10n.languageFiles[lang]) {
                    ["admin"].forEach(function (module) {
                        if (vvL10n.languageFiles[lang][module]) {
                            var staticRoot = vv.getVvMetaData('static_root');
                            gettextCatalog.loadRemote(staticRoot + vvL10n.languageFiles[lang][module]);
                        }
                    });
                }
                moment.locale(lang);
            }
        };
        $rootScope.updateLang(lang);

        $rootScope.getResizedImageSrc = function(source, size) {
            if (source != null && size > 0) {
                var destination = vv.resizedImageUrl(source, size);
                return destination;
            }
            else {
                return '';
            }
        };
    });

    app.run(function($rootScope, $filter, $q) {
        $rootScope.runPromise = function($event, promise) {
            var element = $($event.currentTarget);
            if (element.is('form'))
                element = element.find('button[type="submit"]');
            element.prop('disabled', true);
            $q.when(promise).then(function() {
                element.prop('disabled', false);
            }, function(error) {
                alert(error);
                element.prop('disabled', false);
            });
        };

        $rootScope.timezone = (function() {
            try {
                return Intl.DateTimeFormat().resolvedOptions().timeZone +
                    ' (' + $filter('date')(new Date(), 'Z') + ')';
            } catch (e) {
                return $filter('date')(new Date(), 'Z');
            }
        })();
    });

    app.controller('FaceareaEditModalController', function($scope) {
        var extraKey = 'specialImageFacearea_' + $scope.$index;

        var _move = function(dx, dy) {
            if (!$scope.meaning.extra[extraKey]) {
                return;
            }
            $scope.meaning.extra[extraKey] = $scope.meaning.extra[extraKey].map(function(pos) {
                pos[0] += dx;
                pos[1] += dy;
                return pos;
            });
        };
        $scope.moveLeft = function() {
            _move(-1, 0);
        };
        $scope.moveUp = function() {
            _move(0, -1);
        };
        $scope.moveRight = function() {
            _move(1, 0);
        };
        $scope.moveDown = function() {
            _move(0, 1);
        };
    });

    app.controller('FaceCoordsEditModalController', function($scope) {
        $scope.showIdx = 0;
        $scope.map = [['1. Face outline', ''], ['2. Eyebrows and nose', ''], ['3. Eyes', ''], ['4. Lip', '']];

        $scope.moveLeft = function() {
            $scope.showIdx--;
        };
        $scope.moveRight = function() {
            $scope.showIdx++;
        };

        var staticRoot = vv.getVvMetaData('static_root');
        $scope.sampleImg = staticRoot+'/images/admin/face_'+ ($scope.showIdx + 1) +'.png';

        $scope.$watch('showIdx', function() {
            $scope.sampleImg = staticRoot+'/images/admin/face_'+ ($scope.showIdx + 1) +'.png';
        });

        var onDrawSampleHandlers = [];
        $scope.registerOnDrawSamples = function(level, handler) {
            onDrawSampleHandlers[level] = handler;
        };

        $scope.drawCoordAllFromSample = function() {
            onDrawSampleHandlers.forEach(function (handler) {
                handler();
            })
        };

        $scope.drawCoordFromSample = function(level) {
            onDrawSampleHandlers[level]();
        }
    });

  app.controller('LoginCheckController', function($scope, $rootScope, $http, $window, vvLocalStorage) {
    $scope.logout = function() {
      if ($rootScope.user == null)
        return;

      if ($rootScope.user.type == 'facebook') {
        try {
          FB.logout(function (response) {
            console.log(response)
            // $window.location.reload();
            let delete_cookie = function(name) {
              document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
            }

            var cookies = document.cookie.split(";");
            for (var i = 0; i < cookies.length; i++) {
              if (cookies[i].split("=")[0].indexOf("fblo_") != -1)
                delete_cookie(cookies[i].split("=")[0]);
              if (cookies[i].split("=")[0].indexOf("fbsr_") != -1)
                delete_cookie(cookies[i].split("=")[0]);
              if (cookies[i].split("=")[0].indexOf("fbm_") != -1)
                delete_cookie(cookies[i].split("=")[0]);
            }
          });
        } catch (e) {
          let delete_cookie = function(name) {
            document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
          }

          var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if (cookies[i].split("=")[0].indexOf("fblo_") != -1)
              delete_cookie(cookies[i].split("=")[0]);
            if (cookies[i].split("=")[0].indexOf("fbsr_") != -1)
              delete_cookie(cookies[i].split("=")[0]);
            if (cookies[i].split("=")[0].indexOf("fbm_") != -1)
              delete_cookie(cookies[i].split("=")[0]);
          }
        }
      }

      var hostname = vv.getVvMetaData('use_secure') ? ('https://' + $window.location.hostname) : '';
      $http.post(hostname + '/admin/data/logout.json', {}, {withCredentials: true}).then(function (resp) {
        if (resp.status === 200) {
          $rootScope.user = null;
          $window.location.reload();
        }
      }, function (resp) {
        // $window.location.reload();
      });
    };
  });

    app.controller("LangSelectController", function($scope, $rootScope, $cookies, vv){
        $scope.updateLang = function(lang) {
            var expireDate = new Date();
            expireDate.setFullYear(expireDate.getFullYear() + 1);
            $cookies.put('preferred_lang', lang, {path: '/', expires: expireDate});
            $rootScope.updateLang(lang);
        };
    });


    app.directive("passwordVerify", function() {
       return {
          require: "ngModel",
          scope: {
            passwordVerify: '='
          },
          link: function(scope, element, attrs, ctrl) {
            scope.$watch(function() {
                var combined;

                if (scope.passwordVerify || ctrl.$viewValue) {
                   combined = scope.passwordVerify + '_' + ctrl.$viewValue;
                }
                return combined;
            }, function(value) {
                if (value) {
                    ctrl.$parsers.unshift(function(viewValue) {
                        var origin = scope.passwordVerify;
                        if (origin !== viewValue) {
                            ctrl.$setValidity("passwordVerify", false);
                            return undefined;
                        } else {
                            ctrl.$setValidity("passwordVerify", true);
                            return viewValue;
                        }
                    });
                }
            });
         }
       };
    });

    app.directive('focusOnIf', function ($timeout) {
        return {
            restrict: 'A',
            scope: {
                focusOnIf: '='
            },
            link: function (scope, element, attrs) {
                //Watch the showInput model
                scope.$watch(function () {
                    return scope.focusOnIf;
                }, function () {
                    //If the model changes to true, focus on the element
                    if (scope.focusOnIf) {
                        //Assumes that the element has the focus method
                        //If not, then you can have your own logic to focus here
                        $timeout(function () { element.focus(); }, 10);
                    }
                });
            }
        };
    });

    app.directive('ngEnter', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if(event.which === 13) {
                    scope.$apply(function (){
                        scope.$eval(attrs.ngEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    });

    app.controller("ImageUploadTestController", function($scope) {
        $scope.imageUrls = {
            'GCP': {},
            'AWS': {}
        };
    });

    app.directive("vvImageUploader", function($http, vv, vvPopup, $timeout, gettextCatalog) {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                platform: '@',
                imageType: '@',
                imageSizeDesiredInfo: '=', // {width:1200, height:630, resizeMode: 'crop' or 'fillbg', checkMethod: 'ratio' or 'size'}
                uploaderOptions: '=',
                imageUrl: '=',
                subImageUrl: '=',
                onImageChanged: '&',
                onPreviewClick: '&'
            },
            templateUrl: '/admin/imageUploader.html?_hv=ed4ad17',
            link: function(scope, element, attrs) {
                // scope.uploading = false;
                // scope.succeeded = false;

                // imageSize ()
                if (!scope.imageSizeDesiredInfo) {
                    scope.imageResizeMode = 'crop';
                } else {
                    scope.imageResizeMode = scope.imageSizeDesiredInfo.resizeMode;
                    if (['crop', 'fillbg'].indexOf(scope.imageResizeMode) < 0) {
                        scope.imageResizeMode = 'crop';
                    }
                }
                scope.imageSizeWarning = false;
                scope.imageSizeWarningMessage = null;

                scope.required = false;
                if (scope.uploaderOptions == null)
                    scope.uploaderOptions = {};

                attrs.$observe('required', function(value) {
                    if (value == null)
                        scope.required = false;
                    else
                        scope.required = true;
                });

                scope.platformTarget = scope.platform || vv.getVvMetaData('storagePlatform');
                scope.onFileUploadError = (item, err) => {
                    alert(err && err.message || "Error occured on uploading")
                    console.warn(item, err)
                }
                if (scope.platformTarget == 'GCP') {
                    scope.onFileAdded = function(item) {
                        var params = {};
                        try {
                            var filename = item.$uploader.files[0].name;
                            var ext = filename.split('.').pop();
                            if (ext.toLowerCase() == 'gif') {
                                params['type'] = 'image/gif';
                            } else if (ext.toLowerCase() == 'mp3') {
                                params['type'] = 'audio/mp3';
                            }
                        } catch(e) {}
                        if (scope.uploaderOptions.nolimit)
                            params.nolimit = scope.uploaderOptions.nolimit;
                        if (scope.uploaderOptions.ongcs)
                            params.ongcs = scope.uploaderOptions.ongcs;

                        $http.get('/admin/data/generate-upload-url', {params: params}).success(function(data, status, headers, config) {
                            var max_width = scope.uploaderOptions.max_width || (scope.imageType == 'speimg' ? 800 : 1500);
                            //dummyprofile custom image use small size
                            if (scope.imageType == 'dummyImgY') max_width = 80;
                            if (!item.$uploader) {
                                alert('Failed to get $uploader');
                                return;
                            }
                            item.$uploader.settings.resize = {width: max_width, preserve_headers: false};
                            item.$uploader.settings.url = data;
                            item.$uploader.start();
                        }).error(function(data, status, headers, config) {
                            alert('Failed to generate upload url');
                        });
                    };

                    scope.onFileUploaded = function (item, response) {
                        item.url = response.response;
                        scope.onImageChanged({path: item.url});
                        _showPreviewImage();
                    };
                } else if (scope.platformTarget == 'AWS') {
                    scope.s3bucket = vv.getVvMetaData('s3bucket');
                    scope.s3connInfoUrl = vv.appendSearchToPath('/admin/data/s3-conn-info', scope.uploaderOptions);
                    scope.s3uploadDir = vv.getVvMetaData('storageRoot') + '/editor/';

                    scope.$on('s3upload:success', function(event, xhr, data) {
                        console.log('upload success', data.path);
                        scope.onImageChanged({path : data.path});
                        _showPreviewImage();
                    });

                    scope.$on('s3upload:error', function(event, xhr, message) {
                        var errorCode = (function () {
                            try { return xhr.responseXML.getElementsByTagName("Code")[0].textContent } catch(e) {}
                            return null;
                        })();
                        if (scope.onFileUploadError instanceof Function) {
                            var msg = message || gettextCatalog.getString("Failed to upload image")
                            if (errorCode == 'EntityTooLarge') {
                                msg = gettextCatalog.getString("Too large image. Try another one please")
                            }
                            scope.onFileUploadError(null, { message: msg });
                        }
                    });
                } else if (scope.platformTarget == 'OSS') {
                    scope.ossBucket = vv.getVvMetaData('ossbucket');
                    scope.ossConnInfoUrl = vv.appendSearchToPath('/admin/data/oss-conn-info', scope.uploaderOptions);
                    scope.ossUploadDir = vv.getVvMetaData('storageRoot') + '/editor/';

                    scope.$on('ossupload:success', function(event, xhr, data) {
                        scope.onImageChanged({path: data.path});
                        _showPreviewImage();
                    });
                    scope.$on('ossupload:error', function(event, xhr) {
                        if (scope.onFileUploadError instanceof Function) {
                            scope.onFileUploadError()
                        }
                    })
                }

                var _showPreviewImage = function() {
                    scope.existImageUrl = true;
                    scope.existSubImageUrl = false;
                };

                scope.onFileReset = function() {
                    scope.imageUrl.url = '';
                    scope.onImageChanged({path: ''});
                };

                scope.onPreviewClicked = function() {
                    scope.onPreviewClick();
                };

                var applyCrop = function(croppedImageUrl) {
                    console.log('Crop : Apply, url: ', croppedImageUrl);
                    scope.imageUrl.url = croppedImageUrl;
                    scope.onImageChanged({path: ''});
                    scope.onPreviewClick();
                };

                var closeCropLayer = function() {
                    vvPopup.close();
                };

                scope.openCropLayer = function() {
                    console.log('Crop : Open Layer');
                    var data = {
                        imageUrl: scope.imageUrl.url,
                        applyCrop: applyCrop,
                        closeCropLayer: closeCropLayer,
                        imageResizeMode: scope.imageResizeMode,
                        imageResizeOptions: scope.imageSizeDesiredInfo,
                        imageSizeWarningMessage: scope.imageSizeWarningMessage
                    };

                    vvPopup.openUrl('/admin/layer_resize_image.html?_hv=9357330', data);
                };

                scope.$on('$destroy', function() {
                    if (scope.imageUrl && scope.imageUrl.$uploader)
                        $timeout(function() {
                            scope.imageUrl.$uploader.destroy();
                        }, 0);
                });

                scope.existImageUrl = false;
                scope.existSubImageUrl = false;

                scope.$watch("imageUrl.url", function() {
                    const oldExistImageUrl = scope.existImageUrl;
                    if (scope.imageUrl.url.length > 0) {
                        scope.existImageUrl = true;
                        const imageSizeDesiredInfo = scope.imageSizeDesiredInfo;
                        if (imageSizeDesiredInfo && imageSizeDesiredInfo.checkMethod) {
                            const img = new Image();
                            img.onload = function () {
                                const width = this.width;
                                const height = this.height;
                                let imageSizeWarning;
                                let imageSizeWarningMessage;
                                if (imageSizeDesiredInfo.checkMethod === 'ratio') {
                                    imageSizeWarning = Math.abs(imageSizeDesiredInfo.width/imageSizeDesiredInfo.height - width/height) >= 0.01;
                                    imageSizeWarningMessage = 'The desired aspect ratio is ' +
                                        `${imageSizeDesiredInfo.width}x${imageSizeDesiredInfo.height} (1:${(imageSizeDesiredInfo.width/imageSizeDesiredInfo.height).toPrecision(4)})` +
                                        ' but this image is ' +
                                        `${width}x${height} (1:${(width/height).toPrecision(4)}).`;
                                } else if (imageSizeDesiredInfo.checkMethod === 'size') {
                                    imageSizeWarning = (imageSizeDesiredInfo.width != width) || (imageSizeDesiredInfo.height != height);
                                    imageSizeWarningMessage = `The desired size is (${imageSizeDesiredInfo.width}x${imageSizeDesiredInfo.height}) but this image is (${width}x${height}).`;
                                }
                                $timeout(function() {
                                    scope.imageSizeWarning = imageSizeWarning;
                                    scope.imageSizeWarningMessage = imageSizeWarning ? imageSizeWarningMessage : null;
                                    if (oldExistImageUrl && imageSizeWarning) {
                                        scope.openCropLayer();
                                    }
                                });
                            };
                            img.src = scope.imageUrl.url;
                        }
                    } else {
                        scope.existImageUrl = false;
                        scope.imageSizeWarning = false;
                        scope.imageSizeWarningMessage = null;
                    }
                });

                scope.$watch("subImageUrl.url", function() {
                    if (scope.subImageUrl != undefined && scope.subImageUrl.url.length > 0)
                        scope.existSubImageUrl = true;
                    else
                        scope.existSubImageUrl = false;

                });
            }
        };
    });

    app.controller('ImageFillBackgroundAddonController', function($scope, $http) {
        if ($scope.imageResizeOptions && $scope.imageResizeOptions.width && $scope.imageResizeOptions.height) {
            $scope.params = {
                w: $scope.imageResizeOptions.width,
                h: $scope.imageResizeOptions.height,
                blur: 11,
                brightness: 0.7,
            }
        } else {
            $scope.params = {
                blur: 11,
                brightness: 0.7,
            }
        }

        $scope.fitSizedImageUrl = function() {
            if ($scope.params && $scope.params.w && $scope.params.h) {
                return 'https://img-resizer-dot-img-vonvon.appspot.com/ops?' + $.param(Object.assign(
                    {op: 'fitsize', url: $scope.imageUrl},
                    $scope.params
                ))
            }
            return $scope.imageUrl;
        };

        $scope.apply = function() {
            let fitSizedImageUrl = $scope.fitSizedImageUrl();
            if (fitSizedImageUrl === $scope.imageUrl) {
                if ($scope.closeCropLayer) {
                    $scope.closeCropLayer();
                }
                return;
            }

            $scope.isCropping = true;
            $scope.isError = false;

            $http.post('/admin/data/save_image', {url: fitSizedImageUrl})
                .then(
                    function success(res) {
                        var croppedImageUrl = res.data.image_url;
                        if ($scope.applyCrop && croppedImageUrl) {
                            $scope.applyCrop(croppedImageUrl);
                        }

                        if ($scope.closeCropLayer) {
                            $scope.closeCropLayer();
                        }
                    },
                    function error(res) {
                        $scope.isError = true;
                        $scope.errorMsg = res.data;
                    }
                ).finally(function() {
                    $scope.isCropping = false;
                }
            );
        };
    });

    app.controller('ImageCropAddonController', function($scope, $http, $timeout) {
        $scope.cropArea = {
            enabled: false
        };
        $scope.cropOptions = {
            viewMode: 2,
            dragMode: 'crop',
            cropBoxResizable: true,
            highlight: true,
            minCropBoxWidth: 0,
            minCropBoxHeight: 0,
            aspectRatio: 0
        };

        $scope.isCropping = false;
        $scope.isError = false;
        $scope.useRatio = false;

        if ($scope.imageResizeOptions) {
            const options = $scope.imageResizeOptions;
            if (options.width > 0 && options.height > 0) {
                $scope.useRatio = true;
                $scope.cropOptions.aspectRatio = options.width / options.height;
                $scope.cropOptions.autoCropArea = 1.0;
            }
        }

        $scope.crop = function() {
            $scope.isCropping = true;
            $scope.isError = false;
            var cropArea = $scope.cropArea;
            var data = {
                image_url: $scope.imageUrl,
                crop_info: {
                    top: cropArea.y,
                    left: cropArea.x,
                    width: cropArea.width,
                    height: cropArea.height,
                }
            };

            $http.post('/admin/data/crop_image', data)
                .then(
                    function success(res) {
                        var croppedImageUrl = res.data.image_url;
                        if ($scope.applyCrop && croppedImageUrl) {
                            $scope.applyCrop(croppedImageUrl);
                        }

                        if ($scope.closeCropLayer) {
                            $scope.closeCropLayer();
                        }
                    },
                    function error(res) {
                        $scope.isError = true;
                        $scope.errorMsg = res.data;
                    }
                ).finally(function() {
                    $scope.isCropping = false;
                }
            );
        };

        $scope.setAspectRatio = function() {
            var aspectRatio = 0;
            if ($scope.useRatio)
                aspectRatio = $scope.cropArea.width / $scope.cropArea.height;

            $scope.cropOptions.aspectRatio = aspectRatio;
        };
    });

    app.directive("vvAudioUploader", function($http, vv) {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                platform: '@',
                uploaderOptions: '=',
                audio: '=',
                onAudioChanged: '&',
                playQuestionAudio: '&',
            },
            templateUrl: '/admin/audioUploader.html?_hv=06b53f5',
            link: function(scope, element, attrs) {
                scope.required = false;
                scope.mediaType = "audio";
                if (scope.uploaderOptions == null)
                    scope.uploaderOptions = {};

                attrs.$observe('required', function(value) {
                    if (value == null)
                        scope.required = false;
                    else
                        scope.required = true;
                });
                scope.platformTarget = scope.platform || vv.getVvMetaData('storagePlatform');
                if (scope.platformTarget == 'GCP') {
                  scope.onFileAdded = function(item) {
                      var params = {};
                      /*
                      try {
                          var filename = item.$uploader.files[0].name;
                          var ext = filename.split('.').pop();
                          if (ext.toLowerCase() == 'mp3') {
                              params['type'] = 'audio/mp3';
                          }
                      } catch(e) {}
                      */
                      if (scope.uploaderOptions.nolimit)
                          params.nolimit = scope.uploaderOptions.nolimit;

                      $http.get('/admin/data/generate-upload-url', {params: params}).success(function(data, status, headers, config) {
                          item.$uploader.settings.url = data;
                          item.$uploader.start();
                      }).error(function(data, status, headers, config) {
                          alert('Failed to generate upload url');
                      });
                  };

                  scope.onFileUploaded = function (item, response) {
                      item.url = response.response;
                      scope.onAudioChanged({path: item.url});
                  };
                } else if (scope.platformTarget == 'AWS') {
                  scope.s3bucket = vv.getVvMetaData('s3bucket');
                  scope.s3connInfoUrl = vv.appendSearchToPath('/admin/data/s3-conn-info', scope.uploaderOptions);
                  scope.s3uploadDir = vv.getVvMetaData('storageRoot') + '/editor/';

                  scope.$on('s3upload:success', function(event, xhr, data) {
                    scope.onAudioChanged({path: data.path});
                    scope.audio.status = "Play Audio";
                  });
                } else if (scope.platformTarget == 'OSS') {
                    scope.ossBucket = vv.getVvMetaData('ossbucket');
                    scope.ossConnInfoUrl = vv.appendSearchToPath('/admin/data/oss-conn-info', scope.uploaderOptions);
                    scope.ossUploadDir = vv.getVvMetaData('storageRoot') + '/editor/';

                    scope.$on('ossupload:success', function(event, xhr, data) {
                        scope.onAudioChanged({path: data.path});
                        scope.audio.status = "Play Audio";
                    });
                }

                scope.playAudio = function(){
                  console.log("come to play Sounds", scope.audio.url);
                  scope.playQuestionAudio({path: scope.audio.url});
                };

                scope.onFileReset = function() {
                    scope.audio.url = '';
                    scope.onAudioChanged({path: ''});
                };

                scope.$on('$destroy', function() {
                    if (scope.audio && scope.audio.$uploader)
                        scope.audio.$uploader.destroy();
                });

                scope.existAudio = false;

                scope.$watch("audio.url", function() {
                    if (scope.audio.url.length > 0){
                        scope.existAudio = true;
                        scope.audio_status = 'Play';
                      } else{
                        scope.existAudio = false;
                        scope.audio_status = 'no upload';
                      }
                });

            }
        };
    });

    app.directive('vvFaceareaMarker', function() {
        return {
            restrict: 'E',
            scope: {
                vvImageUrl: '=',
                vvFacearea: '='
            },
            templateUrl: '/admin/facearea_marker.html?_hv=6b0990e',
            link: function(scope, element, attrs) {
                var canvas = element.find("canvas")[0];
                var isMouseDown = false;
                canvas.onmousedown = function (e) {
                    var rect = canvas.getBoundingClientRect();
                    var x1 = e.clientX - rect.left;
                    var y1 = e.clientY - rect.top;
                    if (!scope.vvFacearea) {
                        scope.vvFacearea = [[0, 0], [0, 0]];
                    }
                    scope.vvFacearea[0] = scope.convertCoordDisplayToReal([x1, y1]);
                    isMouseDown = true;
                };
                canvas.onmouseup = function () {
                    isMouseDown = false;
                };
                canvas.onmouseout = function () {
                    isMouseDown = false;
                };
                canvas.onmousemove = function (e) {
                    if (!isMouseDown) return;

                    var rect = canvas.getBoundingClientRect();
                    var x2 = e.clientX - rect.left;
                    var y2 = e.clientY - rect.top;
                    scope.vvFacearea[1] = scope.convertCoordDisplayToReal([x2, y2]);
                    scope.redraw();
                };
                var _clearCanvas = function(ctx) {
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                };
                var _loadImage = function() {
                    var img = new Image();
                    img.src = scope.vvImageUrl;
                    img.onload = function () {
                        var canvas_w = canvas.width,
                            canvas_h = canvas.height;
                        var imgRatio = img.naturalWidth / img.naturalHeight,
                            canvasRatio = canvas_w / canvas_h;
                        var targetImageWidth = canvas_w,
                            targetImageHeight = canvas_h,
                            targetImageTop = 0,
                            targetImageLeft = 0;
                        var scalingRatio;
                        if (imgRatio < canvasRatio) {
                            targetImageWidth = imgRatio * canvas_h;
                            targetImageLeft = (canvas_w - targetImageWidth) / 2;
                            scalingRatio = img.naturalHeight / canvas_h;
                        } else {
                            targetImageHeight = canvas_w / imgRatio;
                            targetImageTop = (canvas_h - targetImageHeight) / 2;
                            scalingRatio = img.naturalWidth / canvas_w;
                        }
                        scope.convertCoordDisplayToReal = function(pts) {
                            var x = pts[0], y = pts[1];
                            x = (x - targetImageLeft) * scalingRatio;
                            y = (y - targetImageTop) * scalingRatio;
                            return [x, y];
                        };
                        scope.convertCoordRealToDisplay = function(pts) {
                            var x = pts[0], y = pts[1];
                            x = x / scalingRatio + targetImageLeft;
                            y = y / scalingRatio + targetImageTop;
                            return [x, y];
                        };
                        scope.drawImage = function(ctx) {
                            ctx.drawImage(img, targetImageLeft, targetImageTop, targetImageWidth, targetImageHeight);
                        };
                        scope.redraw();
                    };
                };
                canvas.onload = function() {
                    _loadImage();
                };
                scope.$watch('vvFacearea', function(newvalue, oldvalue) {
                    scope.redraw();
                });
                scope.$watch('vvImageUrl', function(newvalue, oldvalue) {
                    _loadImage();
                });
                scope.drawImage = function(ctx) {};
                scope.convertCoordRealToDisplay = function(x) { return x; };
                scope.convertCoordDisplayToReal = function(x) { return x; };
                scope.drawGuide = function(ctx) {
                    ctx.lineWidth = 2;
                    ctx.strokeStyle = 'rgba(70, 255, 255, 0.9)';
                    ctx.strokeRect(0, 0, canvas.width, canvas.height);
                    ctx.lineWidth = 1;
                    ctx.beginPath();
                    ctx.moveTo(canvas.width / 2, 0);
                    ctx.lineTo(canvas.width / 2, canvas.height);
                    ctx.stroke();
                };
                scope.drawMarker = function(ctx) {
                    if (!scope.vvFacearea) {
                        return;
                    }
                    var pts1 = scope.convertCoordRealToDisplay(scope.vvFacearea[0]),
                        pts2 = scope.convertCoordRealToDisplay(scope.vvFacearea[1]);
                    var px1 = pts1[0],
                        py1 = pts1[1],
                        px2 = pts2[0],
                        py2 = pts2[1];
                    var x1 = Math.min(px1, px2),
                        y1 = Math.min(py1, py2),
                        x2 = Math.max(px1, px2),
                        y2 = Math.max(py1, py2);
                    if (px1 < px2) {
                        x1 -= (x2 - x1);
                    } else {
                        x2 += (x2 - x1);
                    }
                    if (py1 > py2) {
                        y1 -= (y2 - y1);
                    } else {
                        y2 += (y2 - y1);
                    }
                    if (ctx.ellipse) {
                        var cx = (x1 + x2) / 2,
                            cy = (y1 + y2) / 2,
                            rx = (x2 - x1) / 2,
                            ry = (y2 - y1) / 2;
                        ctx.lineWidth = 3;
                        ctx.strokeStyle = 'rgba(255, 0, 255, 0.5)';
                        ctx.beginPath();
                        ctx.ellipse(cx, cy, rx, ry, 0, 0, 2 * Math.PI);
                        ctx.stroke();
                    }
                    ctx.lineWidth = 3;
                    ctx.strokeStyle = 'rgba(255, 0, 0, 0.8)';
                    ctx.strokeRect(x1, y1, x2 - x1, y2 - y1);
                };
                scope.redraw = function() {
                    var ctx = canvas.getContext('2d');
                    _clearCanvas(ctx);
                    scope.drawImage(ctx);
                    scope.drawGuide(ctx);
                    scope.drawMarker(ctx)
                };
                if (scope.vvImageUrl) {
                    _loadImage();
                }
                scope.fitCenterVertically = function() {

                };
                scope.fitCenterVertically = function() {

                };
            },
            controller: function() {
            }
        }
    });

    app.directive('vvFaceareaCoords', function($timeout) {
        return {
            restrict: 'E',
            scope: {
                vvImageUrl: '=',
                vvFacearea: '=',
                vvIdx: '=',
                vvRegisterOnDrawSamples: '&'
            },
            templateUrl: '/admin/facearea_coords.html?_hv=05c29b7',
            link: function(scope, element, attrs) {
                var canvas = element.find("canvas")[0];
                var ctx = canvas.getContext('2d');
                var point_point = [[1, 9, 17], [1, 5, 6, 10, 11, 15, 17, 19], [1, 4, 7, 10], [1, 3, 5, 7]];

                scope.remainCnt = MAX_POINTS[scope.vvIdx] - (scope.vvFacearea ? scope.vvFacearea.length : 0);

                canvas.onmouseup = function (e) {
                    var rect = canvas.getBoundingClientRect();
                    var x1 = e.clientX - rect.left;
                    var y1 = e.clientY - rect.top;

                    if (!scope.vvFacearea) {
                        scope.vvFacearea = [];
                    }

                    if (scope.vvFacearea.length >= MAX_POINTS[scope.vvIdx])
                        return;

                    $timeout(function(){
                        scope.vvFacearea.push(scope.convertCoordDisplayToReal([x1, y1]));
                        _drawDot(x1, y1);
                    });
                };

                scope.drawFromSample = function() {
                    _clearCanvas(ctx);
                    scope.drawImage(ctx);
                    angular.forEach(SAMPLE_COORDS[scope.vvIdx], function(v, k) {
                        v = scope.convertCoordSampleRealToReal(v);
                        var x = v[0], y = v[1];
                        if (!scope.vvFacearea)
                            scope.vvFacearea = [];
                        if (scope.vvFacearea.length >= MAX_POINTS[scope.vvIdx])
                            return;
                        scope.vvFacearea[k] = [x, y];
                    });
                    scope.drawAll();
                };

                var _drawDot = function(x, y, k) {
                    var idx = k || scope.vvFacearea.length;
                    ctx.beginPath();
                    ctx.arc(x, y, 3, 0, 2 * Math.PI, true);
                    ctx.fillStyle = point_point[scope.vvIdx].indexOf(idx) > -1 ? '#fb2c62' : '#00f3fe';
                    ctx.fill();
                    ctx.font = '10px Georgia';
                    ctx.fillText(idx, x+2, y-5);
                };

                var _clearCanvas = function(ctx) {
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                };
                var _loadImage = function() {
                    var img = new Image();
                    img.src = scope.vvImageUrl;
                    img.onload = function () {
                        var canvas_w = canvas.width, canvas_h = canvas.height,
                            img_h = img.naturalHeight, img_w = img.naturalWidth,
                            sample_img_h = 800, sample_img_w = 800;
                        var imgRatio = img_w / img_h,
                            canvasRatio = canvas_w / canvas_h,
                            sampleImgRatio = sample_img_w / sample_img_h;
                        var targetImageWidth = canvas_w,
                            targetImageHeight = canvas_h,
                            targetImageTop = 0,
                            targetImageLeft = 0;
                        var scalingRatio, sampleImgImgRatio, xDiff, yDiff;

                        if (imgRatio < canvasRatio) {
                            targetImageWidth = imgRatio * canvas_h;
                            targetImageLeft = (canvas_w - targetImageWidth) / 2;
                            scalingRatio = img_h / canvas_h;
                        } else {
                            targetImageHeight = canvas_w / imgRatio;
                            targetImageTop = (canvas_h - targetImageHeight) / 2;
                            scalingRatio = img_w / canvas_w;
                        }
                        if (sampleImgRatio < imgRatio) {
                            sampleImgImgRatio = img_h / sample_img_h;
                            xDiff = (img_w - sample_img_w * sampleImgImgRatio) / 2;
                            yDiff = 0;
                        } else {
                            sampleImgImgRatio = img_w / sample_img_w;
                            xDiff = 0;
                            yDiff = (img_h - sample_img_h * sampleImgImgRatio) / 2;
                        }
                        scope.convertCoordDisplayToReal = function(pts) {
                            var x = pts[0], y = pts[1];
                            x = (x - targetImageLeft) * scalingRatio;
                            y = (y - targetImageTop) * scalingRatio;
                            return [x, y];
                        };
                        scope.convertCoordRealToDisplay = function(pts) {
                            var x = pts[0], y = pts[1];
                            x = x / scalingRatio + targetImageLeft;
                            y = y / scalingRatio + targetImageTop;
                            return [x, y];
                        };
                        scope.convertCoordSampleRealToReal = function(pts) {
                            var x = pts[0], y = pts[1];
                            x = x * sampleImgImgRatio + xDiff;
                            y = y * sampleImgImgRatio + yDiff;
                            return [x, y];
                        };
                        scope.drawImage = function(ctx) {
                            ctx.drawImage(img, targetImageLeft, targetImageTop, targetImageWidth, targetImageHeight);
                        };
                        scope.redraw();
                        scope.drawAll();
                    };
                };
                canvas.onload = function() {
                    _loadImage();
                };
                scope.$watch('vvImageUrl', function(newvalue, oldvalue) {
                    _loadImage();
                });

                scope.$watch('vvFacearea.length', function(n, o) {
                    if (n != o)
                        scope.remainCnt = MAX_POINTS[scope.vvIdx] - (n ? n : 0);
                }, true);

                scope.drawImage = function(ctx) {};
                scope.convertCoordRealToDisplay = function(x) { return x; };
                scope.convertCoordDisplayToReal = function(x) { return x; };
                scope.convertCoordSampleRealToReal = function(x) { return x; };
                scope.vvRegisterOnDrawSamples({level: scope.vvIdx, handler: scope.drawFromSample});
                scope.redraw = function() {
                    _clearCanvas(ctx);
                    scope.drawImage(ctx);
                };
                if (scope.vvImageUrl) {
                    _loadImage();
                }

                scope.drawAll = function() {
                    angular.forEach(scope.vvFacearea, function(v, k) {
                        v = scope.convertCoordRealToDisplay(v);
                        var x = v[0];
                        var y = v[1];
                        _drawDot(x, y, k+1);
                    });
                };

                scope.undo = function() {
                    if (!scope.vvFacearea)
                        return;
                    if (scope.vvFacearea.length < 1)
                        return;

                    scope.vvFacearea.pop();
                    _clearCanvas(ctx);
                    scope.drawImage(ctx);
                    scope.drawAll();
                };

                scope.reset = function() {
                    scope.vvFacearea = null;
                    scope.redraw();
                };

                scope.$watch('vvFacearea', function(n, o) {
                    _clearCanvas(ctx);
                    scope.drawImage(ctx);
                    scope.drawAll();
                });
            },
            controller: function() {
            }
        }
    });

    app.directive('vvColorChooser', function(vvLocalStorage) {
        var currentId = 1;
        var presetColors = ['#ffea00', '#ff0000', '#ff00ff', '#ffffff', '#000000', '#00ffea', '#a50808', '#fcff00', '#ffc609'];
        var favoriteColors = null;

        function initFavoriateColors() {
            if (favoriteColors != null) {
                return favoriteColors;
            }
            var ls_af_colors =  vvLocalStorage.get('af-color');
            if (!ls_af_colors || !Array.isArray(ls_af_colors)) {
                ls_af_colors = [];
            } else {
                ls_af_colors = ls_af_colors.filter(function (item) {
                    return !!item;
                });
            }

            favoriteColors = presetColors.concat(ls_af_colors);
            return favoriteColors;
        }

        return {
            restrict: 'E',
            transclude: true,
            scope: {
                vvColorModel: '=',
                vvColorsModel: '=',
                vvColorsGradientAngleModel: '=',
                onColorChanged: '&'
            },
            templateUrl: '/admin/colorChooser.html?_hv=8ec63d8',
            link: function(scope, element, attrs) {
                var default_color = "#000000";
                scope.id = 'vv-color-chooser-' + currentId++;
                scope.presetColor = presetColors;
                scope.favoriteColors = initFavoriateColors();
                scope.dropdownOpened = false;
                scope.inVisibleRange = false;
                scope.drawCheckbox = !(attrs.vvColorsModel === undefined);
                if(scope.vvColorsModel === undefined) {
                    scope.vvColorsModel = [];
                }
                scope.showColors = scope.vvColorsModel.length > 0;
                scope.vvColorsGradientAngleModel = 0;
                scope.numColors = 1;

                scope.addFavorite = function() {
                    if (scope.favoriteColors.indexOf(scope.vvColorModel) > -1)
                        return;

                    var ls_af_colors =  vvLocalStorage.get('af-color') || [];
                    ls_af_colors.push(scope.vvColorModel);
                    vvLocalStorage.set('af-color', ls_af_colors);

                    scope.favoriteColors.push(scope.vvColorModel);
                };
                scope.setColor = function(color, index) {
                    if(index == null)
                        scope.vvColorModel = color;
                    else
                        scope.vvColorsModel[index] = color;
                };
                scope.onButtonClick = function() {
                    scope.dropdownOpened = true;
                };

                scope.onCheckboxClicked = function() {
                    scope.showColors = !scope.showColors;
                    if(scope.showColors) {
                        scope.vvColorsModel = [default_color, default_color];
                    }
                    else {
                        scope.vvColorsModel = [];
                    }
                };

                scope.addColor = function() {
                    scope.vvColorsModel.push(default_color);
                };

                scope.deleteColor = function() {
                    scope.vvColorsModel.pop();
                };

            }
        };
    });

    app.directive('vvInputChecker', function() {
        return {
            restrict: 'A',
            scope: {
                'vvInput': '=?',
                'vvCondition': '@'
            },
            templateUrl: '/admin/inputChecker.html?_hv=b3e6645',
            link: function(scope, element, attrs) {
                var updateClass = function() {
                    if (scope.vvInput == null)
                        return;

                    if (scope.vvInput.$valid) {
                        if (!scope.vvInput.$modelValue || !scope.vvInput.$modelValue.length) {
                            element.removeClass('vv-valid');
                            element.removeClass('vv-invalid');
                        } else {
                            element.addClass('vv-valid');
                            element.removeClass('vv-invalid');
                        }
                    } else {
                        element.removeClass('vv-valid');
                        element.addClass('vv-invalid');
                    }
                };

                scope.$watch('vvInput.$valid', function() {
                    updateClass();
                });

                scope.$watch('vvInput.$modelValue', function() {
                    updateClass();
                });

                if (scope.vvInput == null) {
                    scope.$watch('vvCondition', function(value) {
                        if (value) {
                            element.addClass('vv-valid');
                            element.removeClass('vv-invalid');
                        } else {
                            element.removeClass('vv-valid');
                            element.addClass('vv-invalid');
                        }
                    });
                }
            }
        };
    });

    app.directive('vvSticky', function() {
        return {
            restrict: 'A',
            scope: {
                top: '@vvStickyTop',
                fixed: '=vvStickyFixed'
            },
            link: function(scope, element, attrs, controller, transcludeFn) {
                var $window = angular.element(window);
                if ($window.width() < 768 || scope.fixed == true)
                    return;

                var addClassName = 'vv-sticky-result';

                var stickyResizeHandler = function() {
                    if (!element.is(':visible') || element.width() == 0)
                        return;

                    if (scope.fixed == true) {
                        element.removeClass(addClassName);
                        return;
                    }

                    var top = parseInt(scope.top) || 0;
                    var $outer = element.parent();
                    if (element.hasClass(addClassName)) {
                        if ($window.width() < 768 || window.scrollY + top <= $outer.offset().top) {
                            $outer.css({
                                'min-height': ''
                            });
                            element.css({
                                position: '',
                                top: '',
                                left: '',
                                width: '',
                                'z-index': ''
                            });
                            element.removeClass(addClassName);
                        }
                    } else {
                        if ($window.width() >= 768 && window.scrollY + top > $outer.offset().top) {
                            $outer.css({
                                'min-height': $outer.height() + 'px'
                            });
                            element.css({
                                position: 'fixed',
                                top: top + 'px',
                                width: element.width() + 'px',
                                'z-index': 100
                            });
                            if (element.hasClass('fix-left')) {
                                element.css({
                                  left: '10px'
                                })
                            }
                            element.addClass(addClassName);
                            // element.children('img, canvas').css({width: '100%'});
                        }
                    }
                };

                $window.on('scroll.vv-sticky', stickyResizeHandler);
                scope.$on('$destroy', function() {
                    $window.off('scroll.vv-sticky', stickyResizeHandler);
                });
            }
        };
    });

    app.controller('TogglerCtrl', function() {
        var $ctrl = this;
        $ctrl.isOn = false;
        $ctrl.toggle = function() {
            $ctrl.isOn = !$ctrl.isOn;
        };
    });

    app.directive('vvMarkupButton', function() {
        return {
            restrict: 'A',
            templateUrl: '/admin/vvmarkup_button.html?_hv=3f1c0af',
            scope: {
                text: '=vvMarkupText'
            },
            controller: function($scope, vvAdminUtils, gettextCatalog) {
                function checkMarkup(text) {
                    text = text.trim();
                    if (text.slice(0, 4) != '[vv]')
                        return false;

                    if (text.slice(-5) != '[/vv]')
                        return false;

                    return true;
                }

                $scope.isUsingMarkup = false;
                $scope.$watch('text', function(value) {
                    $scope.isUsingMarkup = checkMarkup(value);
                });

                $scope.enableMarkup = function() {
                    var text = $scope.text.trim();
                    if (text.slice(0, 4) != '[vv]')
                        text = '[vv]' + text;
                    if (text.slice(-5) != '[/vv]')
                        text = text + '[/vv]';
                    $scope.text = text;
                };

                $scope.disableMarkup = function() {
                    var text = $scope.text.trim();
                    if (text.slice(0, 4) == '[vv]')
                        text = text.slice(4);
                    if (text.slice(-5) == '[/vv]')
                        text = text.slice(0, -5);
                    $scope.text = text;
                };

                $scope.clearMarkup = function() {
                    vvAdminUtils.confirm(gettextCatalog.getString('Are you sure?'))
                        .then(function() {
                            var text = $scope.text.trim();
                            text = text.replace(/\[[a-z-]+([ \t]+[a-z-]+="[^"]*")*]/g, '');
                            text = text.replace(/\[\/[a-z-]+]/g, '');
                            $scope.text = text;
                        });
                };
            }
        }
    });

    app.directive('forceLowercase', function() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {
                var toLowercase = function(inputValue) {
                    inputValue = inputValue || '';
                    var lowercased = inputValue.toLowerCase();
                    if (inputValue !== lowercased) {
                        modelCtrl.$setViewValue(lowercased);
                        modelCtrl.$render();
                    }
                    return lowercased;
                }
                modelCtrl.$parsers.push(toLowercase);
                toLowercase(scope[attrs.ngModel]);
            }
        };
    });

    app.service('vvAdminUtils', function($uibModal, $q, $timeout) {
        this.confirm = function(text) {
            return $uibModal.open({
                templateUrl: '/admin/confirm_modal.html?_hv=39e8a58',
                size: 'sm',
                controller: function($scope, $uibModalInstance) {
                    $scope.text = text;
                    $scope.ok = function($event) {
                        $uibModalInstance.close('ok clicked');
                    };
                    $scope.cancel = function($event) {
                        $uibModalInstance.dismiss('cancel clicked');
                    };
                }
            }).result;
        };

        this.debounce = function(func, wait, immediate) {
            var timeout;
            var deferred = $q.defer();
            return function() {
                var context = this;
                var args = arguments;
                function later() {
                    timeout = null;
                    if(!immediate) {
                        deferred.resolve(func.apply(context, args));
                        deferred = $q.defer();
                    }
                }
                var callNow = immediate && !timeout;
                if (timeout) {
                    $timeout.cancel(timeout);
                }
                timeout = $timeout(later, wait);
                if (callNow) {
                    deferred.resolve(func.apply(context,args));
                    deferred = $q.defer();
                }
                return deferred.promise;
            };
        };
    });
})();
